import Breadcrumb from "@/components/feature/Breadcrumb";

function PlotHeader() {
  return (
    <section className="border-b border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <Breadcrumb items={[{ label: "首页", path: "/" }, { label: "剧情解析" }]} />
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-film-line"></i> 剧情解析
          </span>
          <h1 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
            把嘿咻嘿咻漫画的故事，一格格读懂
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            从剧情速览到结局考据，从伏笔盘点再到创作解读，这里汇集了嘿咻嘿咻漫画最完整的剧情脉络与深度解析，帮你快速理清走向、读透结局。
          </p>
        </div>
      </div>
    </section>
  );
}

export default PlotHeader;